import { GQuery, useLazyQuerySaga } from 'hooks/useQuerySaga';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Product, QueryProductSearchArgs } from 'types/schema';
import { productSearch } from 'utils/query';

export function useProductSearch(excludeId?: string) {
  const [search, { loading }] = useLazyQuerySaga<GQuery<'productSearch'>, QueryProductSearchArgs>(productSearch, {
    authentication: false,
  });
  const [results, setResults] = useState<Product[]>([]);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const searchProducts = useCallback(
    (query: string) => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      if (!query.trim()) {
        setResults([]);
        return;
      }
      debounceRef.current = setTimeout(async () => {
        const regionCode = window.localStorage.getItem('region') || 'HCM';
        try {
          const data = await search({
            variables: {
              sort: [],
              filter: { query: query.trim(), regionCode: regionCode },
              pagination: { page: 0, size: 50 },
            },
          });
          const list = (data?.data ?? []).filter(Boolean) as Product[];
          setResults(excludeId ? list.filter((p) => p.id !== excludeId) : list);
        } catch {
          setResults([]);
        }
      }, 300);
    },
    [search, excludeId],
  );

  useEffect(
    () => () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    },
    [],
  );

  return { results: results, loading: loading, searchProducts: searchProducts, clearResults: () => setResults([]) };
}
